import { initI18n } from '@altirllc/shared/utils/i18n';

const importLocale = (language: string, namespace: string) =>
  import(/* webpackChunkName: "locales/" */ `../public/locales/${language}/${namespace}.json`);

initI18n(importLocale);
